<template>
	<div>
		<!-- <h3 class="text-center my-4">
			Glissez-déposez pour modifier l'ordre, ou renommez vos colonnes
		</h3> -->

		<b-button
            v-b-tooltip.hover="{
                variant: 'info',
                title: 'Si les données précédentes ne sont pas mises à jour, cliquez ici pour actualiser le mapping',
            }"
			class="m-md-2"
			variant="outline-primary"
			@click="$emit('regenerate-columns')">
			Actualiser les colonnes
		</b-button>

		<!-- <div class="flex mb-2 justify-between">
			<h4 class="w-[40%] mr-2">Origine</h4>
			<h4 class="w-[40%] mr-2">Destination</h4>
		</div>
		<draggable
			:list="columns"
			class="mb-2"
			handle=".handle"
			@end="debugColumns">
			<div
				class="handle cursor-grab hover:bg-slate-400"
				v-for="(column, i) in columns"
				:key="column.colonne + i">
				<div class="flex mb-2 justify-between">
					<select class="w-[40%] mr-2 rounded-lg focus:outline-none" v-model="column.colonne">
                        <option
                            class=""
                            v-for="option in availableColumns"
                            :value="option">
                            {{ option }}
                        </option>
                    </select>
					<input class="w-[40%] mr-2 rounded-lg focus:outline-none" v-model="column.colonne">
					<autocomplete
						class="w-[40%] mr-2 rounded-lg focus:outline-none"
						@submit="(val) => modifyLeftColumn(val, i)"
						:search="search"
						:autoSelect="true"
						:defaultValue="column.colonne">
					</autocomplete>

					<input
						class="w-[40%] mx-2 rounded-lg focus:outline-none border-none"
						v-model="column.mapping" />

					<span
						class="cursor-pointer mt-3"
						@click="() => columns.splice(i, 1)">
						<i class="fa fa-times fa-lg" aria-hidden="true"></i>
					</span>
				</div>
			</div>
		</draggable>

		<div>
			<b-button
				class="m-md-2"
				variant="outline-primary"
				@click="
					() =>
						columns.push({
							colonne:
								initialColumns.length > 0
									? initialColumns[0].colonne
									: 'Colonne',
							mapping:
								initialColumns.length > 0
									? initialColumns[0].mapping
									: 'Mapping',
						})
				">
				Nouveau mapping
			</b-button>
		</div> -->
	</div>
</template>

<style>
	/* On peut override le style autocomplete ici */
	.autocomplete-input {
		background-color: white !important;
	}
</style>

<script>
	var clone = require("clone");

	import draggable from "vuedraggable";
	import Autocomplete from "@trevoreyre/autocomplete-vue";

	export default {
		name: "mapping_step",
		components: {
			draggable: draggable,
			Autocomplete,
		},
		props: {
			initialColumns: Array,
			availableColumns: Array,
			orderPreference: String,
		},
		data() {
			return {
				columns: this.initialColumns ? clone(this.initialColumns) : [],
			};
		},
		computed: {},
		watch: {
			columns: {
				deep: true,
				handler(newColumns) {
					this.updatedColumns();
				},
			},
		},
		methods: {
			setColumnMapping(initialColumns) {
				// this.initialColumns = initialColumns;
				if (initialColumns.length > 0) {
					this.columns = clone(initialColumns);
					console.log("Columns has been set", this.columns);
				}
			},
			modifyLeftColumn(val, i) {
				this.columns[i].colonne = val;
				this.columns[i].mapping = val;
			},
			search(input) {
				if (input.length < 1) {
					return this.availableColumns;
				}

				// console.log(this.availableColumns);

				let filteredCols = this.availableColumns.filter(
					(availableCol) => {
						return availableCol.includes(input);
					}
				);

				// console.log(filteredCols);
				return filteredCols;
			},
			debugColumns() {
				console.log(this.columns);
			},
			updatedColumns() {
				// console.log("Emit mappingUpdated ", this.columns);
				this.$emit("mapping-updated", this.columns);
			},
		},
		mounted() {
			if (this.orderPreference === "alphabetical") {
				this.availableColumns.sort((a, b) => {
					let lowerCaseA = a.toLowerCase(),
						lowerCaseB = b.toLowerCase();

					if (lowerCaseA < lowerCaseB) return -1;
					if (lowerCaseA > lowerCaseB) return 1;
					return 0;
				});
			}
		},
	};
</script>
